var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerritoireRecto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 552 555.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#12171c;}.cls-1,.cls-5{stroke:#12171c;}.cls-1,.cls-3,.cls-5,.cls-6{stroke-miterlimit:10;}.cls-2,.cls-3,.cls-6{fill:#fff;}.cls-3,.cls-6{stroke:#33163a;}.cls-4{fill:#dbf226;}.cls-5{fill:none;stroke-width:2px;}.cls-6{opacity:0.82;}.cls-7{fill:#052941;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "territoire recto") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_7",
    "data-name": "Calque 7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.5,
    y: 10,
    width: 550,
    height: 545,
    rx: 24.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.5,
    y: 1,
    width: 550,
    height: 545,
    rx: 24.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 26.18,
    y: 17.54,
    width: 499.77,
    height: 452.46,
    rx: 28.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M657,1001c252.5,116.5,496-192,330-419.5l195,.5c17,1,29,11,25,34V850s-6.52,189-218.26,276.5C812,1126,682,1127,682,1127c-12,0-26-10-24-33Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1.5,
    y: 1,
    width: 549.5,
    height: 545,
    rx: 24.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 26.18,
    y: 17.54,
    width: 499.77,
    height: 452.46,
    rx: 28.07
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_9",
    "data-name": "Calque 9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M871.54,1080.16v-2.74h14.52v2.74Zm5.82,17.84v-18.9h2.88V1098Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M892.51,1098.22a6.34,6.34,0,0,1-4.76-1.72,6.66,6.66,0,0,1-1.69-4.87V1090a7.3,7.3,0,0,1,1.63-5.08,5.82,5.82,0,0,1,4.56-1.8,5.06,5.06,0,0,1,4.3,2,9.44,9.44,0,0,1,1.52,5.72v1h-9.91v-2.33h7.16a5,5,0,0,0-.92-2.79,2.61,2.61,0,0,0-2.15-1,3.12,3.12,0,0,0-2.53,1.08,4.54,4.54,0,0,0-.91,3v1.87a3.78,3.78,0,0,0,1,2.8,3.69,3.69,0,0,0,2.73,1,4.7,4.7,0,0,0,1.74-.35,5,5,0,0,0,1.54-1l1.9,1.9a7.92,7.92,0,0,1-2.45,1.62A6.87,6.87,0,0,1,892.51,1098.22Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M902,1098v-14.69h2.89V1098Zm8.08-11.21a2.37,2.37,0,0,0-1-.71,3.54,3.54,0,0,0-1.35-.24,2.88,2.88,0,0,0-2.13.76,2.84,2.84,0,0,0-.75,2.1l-.3-2.83a5.23,5.23,0,0,1,1.75-2,4.14,4.14,0,0,1,2.38-.74,5.47,5.47,0,0,1,1.82.29,4.14,4.14,0,0,1,1.43.86Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M914.41,1098v-14.69h2.89V1098Zm8.09-11.21a2.51,2.51,0,0,0-1-.71,3.54,3.54,0,0,0-1.35-.24,2.85,2.85,0,0,0-2.13.76,2.8,2.8,0,0,0-.76,2.1l-.3-2.83a5.4,5.4,0,0,1,1.75-2,4.19,4.19,0,0,1,2.39-.74,5.47,5.47,0,0,1,1.82.29,4.1,4.1,0,0,1,1.42.86Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M926.79,1080.3v-2.88h2.89v2.88Zm0,17.7v-14.69h2.89V1098Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M932.93,1085.91v-2.6h6.63v2.6Zm5,12.16a3.2,3.2,0,0,1-2.63-1,4.5,4.5,0,0,1-.81-2.89V1079h2.89v15.18a1.4,1.4,0,0,0,.21.82.71.71,0,0,0,.62.3h1.39v2.74Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M949.16,1098.22a5.84,5.84,0,0,1-4.47-1.68,6.59,6.59,0,0,1-1.59-4.72v-2.4a6.46,6.46,0,0,1,1.59-4.67,6.86,6.86,0,0,1,8.95,0,6.5,6.5,0,0,1,1.58,4.67v2.44a6.55,6.55,0,0,1-1.58,4.69A5.9,5.9,0,0,1,949.16,1098.22Zm0-2.75a3,3,0,0,0,2.35-1,3.92,3.92,0,0,0,.82-2.66v-2.44a3.85,3.85,0,0,0-.82-2.64,3,3,0,0,0-2.35-.94,2.93,2.93,0,0,0-2.33.94,3.8,3.8,0,0,0-.84,2.64v2.44a3.88,3.88,0,0,0,.84,2.66A2.94,2.94,0,0,0,949.16,1095.47Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M959.33,1080.3v-2.88h2.89v2.88Zm0,17.7v-14.69h2.89V1098Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M966.61,1098v-14.69h2.89V1098Zm8.08-11.21a2.37,2.37,0,0,0-1-.71,3.54,3.54,0,0,0-1.35-.24,2.88,2.88,0,0,0-2.13.76,2.84,2.84,0,0,0-.75,2.1l-.3-2.83a5.32,5.32,0,0,1,1.75-2,4.14,4.14,0,0,1,2.38-.74,5.47,5.47,0,0,1,1.82.29,4.14,4.14,0,0,1,1.43.86Z",
    transform: "translate(-656 -580.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M984.72,1098.22a6.34,6.34,0,0,1-4.76-1.72,6.66,6.66,0,0,1-1.69-4.87V1090a7.35,7.35,0,0,1,1.63-5.08,5.82,5.82,0,0,1,4.56-1.8,5,5,0,0,1,4.3,2,9.37,9.37,0,0,1,1.52,5.72v1h-9.91v-2.33h7.17a5,5,0,0,0-.93-2.79,2.61,2.61,0,0,0-2.15-1,3.12,3.12,0,0,0-2.53,1.08,4.54,4.54,0,0,0-.91,3v1.87a3.82,3.82,0,0,0,1,2.8,3.69,3.69,0,0,0,2.73,1,4.7,4.7,0,0,0,1.74-.35,4.93,4.93,0,0,0,1.54-1l1.9,1.9a7.92,7.92,0,0,1-2.45,1.62A6.87,6.87,0,0,1,984.72,1098.22Z",
    transform: "translate(-656 -580.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerritoireRecto);
export default __webpack_public_path__ + "static/media/territoire_recto.330f8f27e1afa337e92b9198de9e7217.svg";
export { ForwardRef as ReactComponent };